import React from 'react';
import { BrainIcon, CompassIcon, GaugeIcon, LayersIcon, ScanSearchIcon, TargetIcon } from 'lucide-react';
import { MaskText, Reveal, SectionLabel } from './ui/Reveal';
const reasons = [{
  icon: BrainIcon,
  title: 'Creative thinking',
  copy: 'Ideas that come from the brief, not from a template library.'
}, {
  icon: TargetIcon,
  title: 'Strategic design',
  copy: 'Every decision is justified by what the brand needs to achieve.'
}, {
  icon: LayersIcon,
  title: 'Strong visual systems',
  copy: 'Work that scales past one deliverable into a consistent language.'
}, {
  icon: CompassIcon,
  title: 'Business understanding',
  copy: 'We design for customers, positioning and conversion — not just applause.'
}, {
  icon: ScanSearchIcon,
  title: 'Attention to detail',
  copy: 'Spacing, weight, contrast, alignment. Details decide credibility.'
}, {
  icon: GaugeIcon,
  title: 'Modern execution',
  copy: 'Current craft and fast turnarounds, with 24-hour support.'
}];
export function WhyMorvix() {
  return <section className="bg-surface py-20 sm:py-28" aria-label="Why Morvix" data-id="element-612" data-mp="2kxqvkt1zssbm">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-613" data-mp="2zm4zl7b5amtr">
        <div className="grid gap-6 lg:grid-cols-[1.2fr_1fr] lg:items-end" data-id="element-614" data-mp="2zng2z60ohskc">
          <div data-id="element-615" data-mp="2uumxuh1asi7q">
            <SectionLabel data-id="element-616" data-mp="2uu3qfu99xc7y">Why Morvix</SectionLabel>
            <h2 className="mt-5 font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tightest sm:text-6xl" data-id="element-617" data-mp="38ma5te4lrf6c">
              <MaskText text="Design with purpose.|Creativity with strategy." data-id="element-618" data-mp="33mx8u0k0orq1" />
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-muted sm:text-lg" data-id="element-619" data-mp="3ikh9wwdsm2qx">
            We work as a creative partner, not a vendor taking orders. That means asking harder
            questions early and delivering work that holds up in the market.
          </p>
        </div>

        <div className="mt-14 grid divide-y divide-line border-y border-line sm:grid-cols-2 sm:divide-x lg:grid-cols-3" data-id="element-620" data-mp="1j8wxzexa790h">
          {reasons.map((reason, index) => <Reveal key={reason.title} delay={index * 0.05} className="group p-6 transition-colors duration-500 hover:bg-surface2 sm:p-8" data-id="element-621" data-mp="2cxcgdg7x0zow" data-mpi={index}>
              <reason.icon className="h-5 w-5 text-brand transition-transform duration-500 group-hover:-translate-y-1" aria-hidden="true" data-id="element-622" data-mp="2mvik83da8fwe" />
              <h3 className="mt-6 font-display text-xl font-bold uppercase tracking-tight" data-id="element-623" data-mp="2rt25hn8edsxu">
                {reason.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-624" data-mp="30o85g5kzlgsg">{reason.copy}</p>
            </Reveal>)}
        </div>
      </div>
    </section>;
}